import {
  GetAllProductsRequestBuilder,
  GetProductsCountRequestBuilder,
  UpdateProductRequestBuilder,
  CreateProductRequestBuilder,
  GetProductsInventoryRequestBuilder,
  GetProductsVariantRequestBuilder,
  GetVariantsRequestBuilder,
  GetCategoriesRequestBuilder,
  GetProductsVariantInventoryItemsRequestBuilder,
  GetPartnerCategoriesBuilder,
  SubmitProductInfo,
  GetVitrinCategories,
  CreateVitrinProduct,
  GetVitrinProduct,
  UploadImage,
  GetImage,
  RemoveImage,
  RemoveVitrinProduct,
  UpdateVitrinProduct,
  GetVitrinProductById,
  GetAllVitrinProductsRequestBuilder,
  GetVitrinProductCount,
  UnSelectVitrinProduct,
  SelectVitrinProduct,
  GetVitrinSelectedProducts,
  GetVitrinSelectedProductsCount,
  DeleteVariantsBuilder,
} from '../products/products';
import Client, {VitrinClient} from '../client';
import {flattenObject} from '../helpers';
import { GetPackageConfigsRequestBuilder, CreatePackageConfigRequestBuilder, UpdatePackageConfigRequestBuilder, CreateCustomizedItemRequestBuilder } from '../package-config/packageConfig';

const token = localStorage.getItem('token') || '';

class PackageConfigRepository {
  getPackageConfigById = async (actions: any) => {
    const makeRequest = new GetPackageConfigsRequestBuilder()
    .id(actions.payload.id)
    .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  createPackageConfig = async (actions: any) => {
    const makeRequest = new CreatePackageConfigRequestBuilder()
    .data(actions.payload)
    .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  updatePackageConfig = async (actions: any) => {
    const makeRequest = new UpdatePackageConfigRequestBuilder()
    .data(actions.payload)
    .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  createCustomizedItem = async (actions: any) => {
    const makeRequest = new CreateCustomizedItemRequestBuilder()
    .data(actions.payload)
    .id(actions.id)
    .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
}

export default new PackageConfigRepository();
